/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress } from "@mui/material";
import DateTimePicker from "components/ui/dateTimePicker";
import InputField from "components/ui/inputField";
import MultiSelect from "components/ui/multiSelect";
import Select from "components/ui/select";
import { createPayment, updatePayment } from "features/payments/api/payments";
import validationSchema from "features/payments/schema";
import { useFormik } from "formik";
import useApi from "hooks/useApi";
import useBase from "hooks/useBase";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiLeftArrowAlt } from "react-icons/bi";
import handleError from "utils/handleError";

const MakePayment = ({
  invoice_id,
  setReload,
  currPayment,
  setAddPayment,
  invoices,
  paymentMethods,
  currencies,
  settings,
  banks,
}) => {
  const isUpdating = currPayment?.id ? true : false;
  const [fullPayment, setFullPayment] = useState(currPayment);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const { updateBase } = useBase();

  const currency_id = settings?.app?.currency_id;

  // const [attachment, setAttachment] = useState(null);
  const { fetchData, loading } = useApi();
  const { loading: loadingPaymentDetails, fetchData: fetchDataPaymentDetails } =
    useApi();
  const { loading: loadingInvoiceDetails, fetchData: fetchDataInvoiceDetails } =
    useApi();

  useEffect(() => {
    const getFullPayment = async () => {
      const endpoint = {
        method: "get",
        url: `/api/admin/payment/show/${currPayment?.id}`,
      };
      const result = await fetchDataPaymentDetails(endpoint, false);
      result.success && setFullPayment(result?.data);
    };
    currPayment?.id && getFullPayment();
  }, [isUpdating]);

  const onSubmit = async (data) => {
    // const formData = new FormData();

    // Object.keys(data).forEach((key) => {
    //   if (key === "purpose" && Array.isArray(data[key])) {
    //     // Send purpose as JSON string
    //     formData.append("purpose", JSON.stringify(data[key]));
    //   } else {
    //     formData.append(key, data[key]);
    //   }
    // });
    // if (attachment) {
    //   formData.append("file", attachment);
    // }

    const result = await fetchData(
      isUpdating ? updatePayment(fullPayment.id, data) : createPayment(data),
    );
    if (result?.success) {
      setAddPayment(false);
      setReload((pre) => !pre);
    } else {
      handleError(result, formik);
    }
  };

  const initialValues = {
    invoice_id: fullPayment?.invoice_id || currPayment?.id || invoice_id || "",
    payment_method_id:
      fullPayment?.payment_method_id ||
      paymentMethods?.find((item) => item?.name === "Cash")?.id ||
      "",
    payment_date: fullPayment?.payment_date || moment().format("YYYY-MM-DD"),
    currency_id: fullPayment?.currency_id || currency_id || "",
    amount: fullPayment?.amount || "",
    transaction_id: fullPayment?.transaction_id || "",
    note: fullPayment?.note || "",
    bank_id: fullPayment?.bank_id || "",
    purpose: fullPayment?.purpose || [],
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  // const handleUplodFile = (files) => {
  //   setAttachment(files[0]);
  // };

  useEffect(() => {
    updateBase(["invoices", "paymentMethods", "currencies", "banks"]);
  }, []);

  useEffect(() => {
    const getInvoiceDetails = async () => {
      const endpoint = {
        method: "get",
        url: `/api/admin/invoice/show/${formik.values.invoice_id}`,
      };
      const { success, data } = await fetchDataInvoiceDetails(endpoint, false);
      if (success) setInvoiceDetails(data);
    };
    if (formik.values.invoice_id) {
      getInvoiceDetails();
    }
  }, [formik.values.invoice_id]);

  return (
    <Box sx={{ m: "-10px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<BiLeftArrowAlt />}
          onClick={() => setAddPayment(false)}
        >
          View Invoices
        </Button>
        {/* <Button
          component="label"
          startIcon={<UploadFileSharp />}
          variant="outlined"
        >
          <input
            type="file"
            hidden
            onChange={(e) => handleUplodFile(e.target.files)}
          />
          Attach Files
        </Button> */}
      </Box>
      <Box py="20px">
        {/* {attachment && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "50px auto 100px",
              alignItems: "center",
              borderBottom: "1px solid #ddd",
              pb: "10px",
              mb: "15px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <FcFile style={{ fontSize: "40px" }} />
            </Box>
            <Box>
              <Typography variant="h6">{attachment?.name}</Typography>
              <Typography sx={{ fontSize: "12px" }}>
                {(attachment?.size / 1024).toFixed(0)}KB
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <IconButton onClick={() => setAttachment(null)}>
                <Delete />
              </IconButton>
            </Box>
          </Box>
        )} */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "15px",
            pb: "15px",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Select
              disabled
              options={invoices}
              label="Invoice"
              value={formik?.values?.invoice_id}
              onChange={(value) => formik.setFieldValue("invoice_id", value)}
              selectProps={{ id: "id", label: "name" }}
            />
            {loadingPaymentDetails && (
              <CircularProgress
                size={20}
                sx={{
                  position: "absolute",
                  right: "10px",
                  top: "23%",
                  transform: "translateY(-23%)",
                }}
              />
            )}
          </Box>

          <InputField
            label="Transaction ID"
            name="transaction_id"
            formik={formik}
          />
          <DateTimePicker
            name="payment_date"
            label="Payment Date *"
            type="date" // time
            formik={formik}
          />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "15px",
            }}
          >
            <Select
              options={paymentMethods}
              label="Pay Method *"
              value={formik?.values?.payment_method_id}
              onChange={(value) =>
                formik.setFieldValue("payment_method_id", value)
              }
              selectProps={{ id: "id", label: "name" }}
            />
            <Select
              options={banks}
              label="Banks"
              value={formik?.values?.bank_id}
              onChange={(value) => formik.setFieldValue("bank_id", value)}
              selectProps={{ id: "id", label: "label" }}
            />
          </Box>
          <Select
            options={currencies}
            label="Currency *"
            value={formik?.values?.currency_id}
            onChange={(value) => formik.setFieldValue("currency_id", value)}
            selectProps={{ id: "id", label: "name" }}
          />
          <InputField label="Amount *" name="amount" formik={formik} />

          <MultiSelect
            options={invoiceDetails?.invoice_details || []}
            label="Purpose"
            value={
              // Derive selected ids from formatted purpose strings
              (invoiceDetails?.invoice_details || [])
                .filter((detail) =>
                  (formik?.values?.purpose || []).includes(
                    detail.refund_type
                      ? `${detail.item} (${detail.refund_type})`
                      : detail.item,
                  ),
                )
                .map((detail) => detail.id)
            }
            onChange={(selectedIds) => {
              // Format selected items as "item (refund_type)" or just "item"
              const formattedPurpose = (invoiceDetails?.invoice_details || [])
                .filter((detail) => selectedIds.includes(detail.id))
                .map((detail) =>
                  detail.refund_type
                    ? `${detail.item} (${detail.refund_type})`
                    : detail.item,
                );
              formik.setFieldValue("purpose", formattedPurpose);
            }}
            selectProps={{ id: "id", label: "item" }}
            disabled={
              formik.values.invoice_id ? false : true || loadingInvoiceDetails
            }
          />

          <InputField
            sx={{ gridColumn: "span 2" }}
            name="note"
            label="Note"
            multiline
            rows={2}
            formik={formik}
          />
          <Button
            sx={{ gridColumn: "span 2" }}
            variant="solid"
            onClick={formik.submitForm}
            fullWidth
            disabled={!(formik.dirty && formik.isValid) || loading}
          >
            {isUpdating ? "Update Payment" : "Save Payment"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MakePayment;